import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import MainLayoutComponent from '../../core/components/mainLayout/MainLayoutComponent';
import ContentContainer from './content/ContentContainer';
import AsideContainer from './aside/AsideContainer';
import { alphabets } from '../fontCreator/fontCreatorAuth/constants';
import { AppStateTypes } from '../../store/appStateTypes';

const testRussianFont = Object.values(alphabets.ru).map((symbolCode) => String.fromCharCode(Number(symbolCode)));

const MainContainer: FC = () => {
  const { user } = useSelector((state: AppStateTypes) => state.auth);

  const initialText = user?.id ? testRussianFont.join(' ') : '';

  const [text, setText] = useState(initialText);

  const onChangeText = (value: string) => setText(value);

  return (
        <MainLayoutComponent
            Content={<ContentContainer text={text} />}
            AsideRight={<AsideContainer text={text} onChangeText={onChangeText} />}
        />
  );
};

export default MainContainer;
